module.exports = "/images/vendor/desiigner-svg/svg/logos/48-ore-bologna.svg?417e86cace550bde4c7c1cdda7304149";